module.exports = __webpack_public_path__ + "static/img/12.39a472e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/2/eng/12.png
// module id = zm4X
// module chunks = 0